import { Component } from '@angular/core';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { NavController} from '@ionic/angular';
import { Router } from '@angular/router';


@Component({
    selector: 'score-board-modal-wallen',
    templateUrl: 'score-board-wallen.html',
    styleUrls:['./score-board-wallen.scss']
  })

  export class ScoreBoardWallen {

    // scoreBoardArray = [];
    wallenArray = [];
    isWallen: boolean = false;
    routerState:any;

      constructor (private storage: StorageProvider,
        private navCtrl: NavController, private router:Router) {
        const nav = this.router.getCurrentNavigation();
        this.routerState = nav?.extras?.state || {};
        // this.getAthletes();
        this.getArray();
      }
      // async getAthletes(){
      //   await this.storage.getSaved('score-board').then((data) => this.scoreBoardArray = data);
      //   console.log("athletes" + this.scoreBoardArray);
      // }
      async getArray() {
         this.wallenArray = this.wallenArray.concat(this.routerState['array']);
         this.isWallen = true;
         console.log("ath wallen arr " + JSON.stringify(this.wallenArray));
      }

      onBackMenu() {
        this.wallenArray.length = 0;
        this.navCtrl.pop();
      }
  }